import React from 'react';
import { Box, Stack, SxProps, Typography, useTheme } from '@mui/material';
import { PulsingDot } from 'common/ui';

const container: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

type Props = {
  isLive: boolean;
};

/** @deprecated use v2 */
export const LiveStatusIndicator: React.FC<Props> = ({ isLive }) => {
  const { palette } = useTheme();

  return (
    <Box sx={container}>
      <Typography variant="subtitle1">
        {isLive ? 'Live updates' : 'Offline'}
      </Typography>
      {isLive && <PulsingDot color={palette.success.dark} />}
    </Box>
  );
};

export const LiveStatusIndicatorV2: React.FC<Props> = ({ isLive }) => {
  const { palette } = useTheme();
  return (
    <Stack direction="row" alignItems="center" gap="8px">
      <Typography variant="subtitle1">
        {isLive ? 'Live updates' : 'Offline'}
      </Typography>
      {isLive && <PulsingDot color={palette.successV2.main} />}
    </Stack>
  );
};
